const firebaseConfig =  {
    apiKey: "AIzaSyD2xhVEJ8YPkRgi-GeSzGh5YPUTVIjCp24",
    authDomain: "mining-israa-group.firebaseapp.com",
    databaseURL: "https://mining-israa-group-default-rtdb.firebaseio.com",
    projectId: "mining-israa-group",
    storageBucket: "mining-israa-group.appspot.com",
    messagingSenderId: "278626203823",
    appId: "1:278626203823:web:ef1ada956cd1ce4d7c3c5a",
    measurementId: "G-22R855KE13"
  };
  
    // App Engine / Debug
    const backendUrl = 'http://localhost:8080'
    
    export default {
      firebaseConfig,
      backendUrl
    }